// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".session-wrapper p[data-v-718bcffb]{font-weight:bold;text-align:center}.media-list-wrapper[data-v-718bcffb]{margin-top:15px}\n", ""]);
// Exports
module.exports = exports;
